import { useCallback, useState } from 'react';
import { updateOrderVariantInfo } from '../../api/variantsApi';
import { type UpdateVariantInfoRequestParams } from '../../types/UpdateVariantInfoRequestParams';

export const useUpdateOrderVariants = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<unknown>(null);

    const updateOrderVariants = useCallback(
        async (params: UpdateVariantInfoRequestParams) => {
            if (isLoading) {
                return;
            }

            try {
                setIsLoading(true);

                await updateOrderVariantInfo(params);
            } catch (error) {
                setError(error);

                throw error;
            } finally {
                setIsLoading(false);
            }
        },
        [isLoading]
    );

    return {
        isLoading,
        error,
        updateOrderVariants,
    };
};
